// frontend/my-react-app/src/Header.jsx
// Created: 2025-10-13 (refactored from SimpleHeader.jsx)
// Updated: 2026-03-09 — added Medications nav link; smart logo-click (resets date on dashboard, navigates home elsewhere)
// Updated: 2026-03-10 — restored mobile nav (hamburger, Home + Medications links)
// Updated: 2026-03-10 — logo as Link to /d (clickable); Dashboard + Medications nav links
// Main navigation header: logo placeholder, Dashboard + Medications links, pet switcher, mobile menu.
import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import PetSwitcher from './PetSwitcher';
import './Header.css';

const Header = ({ onTodayClick }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const isDashboard = location.pathname === '/' || location.pathname === '/d';

  const handleDashboardClick = () => {
    if (isDashboard && onTodayClick) {
      onTodayClick();
    } else {
      navigate('/d');
    }
    setIsMobileMenuOpen(false);
  };

  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  return (
    <header className="simple-header">
      <div className="header-content">
        {/* Left side - Hamburger (mobile) + Logo placeholder + Desktop Nav */}
        <div className="left-section">
          <button
            type="button"
            className="hamburger"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-expanded={isMobileMenuOpen}
            aria-label="Open menu"
          >
            {isMobileMenuOpen ? '✕' : '☰'}
          </button>
          {/* Logo — clickable, goes to dashboard (or resets date when already there) */}
          <Link
            to="/d"
            className="logo"
            onClick={(e) => { if (isDashboard && onTodayClick) { e.preventDefault(); onTodayClick(); } }}
            aria-label="Go to dashboard"
          >
            <span className="logo-text">Barking Meds</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="desktop-nav">
            <Link
              to="/d"
              className={`nav-link${isDashboard ? ' active' : ''}`}
              onClick={(e) => { if (isDashboard && onTodayClick) { e.preventDefault(); onTodayClick(); } }}
            >
              Dashboard
            </Link>
            <Link
              to="/meds"
              className={`nav-link${location.pathname.startsWith('/meds') ? ' active' : ''}`}
            >
              Medications
            </Link>
          </nav>
        </div>

        {/* Right side - Pet Switcher */}
        <PetSwitcher />
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="mobile-menu">
          <Link
            to="/d"
            className={`mobile-nav-link${isDashboard ? ' active' : ''}`}
            onClick={handleDashboardClick}
          >
            Dashboard
          </Link>
          <Link
            to="/meds"
            className={`mobile-nav-link${location.pathname.startsWith('/meds') ? ' active' : ''}`}
            onClick={closeMobileMenu}
          >
            Medications
          </Link>
        </div>
      )}
    </header>
  );
};

export default Header;